exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".btn.btn-border[_v-db214e4c]{padding:4px 14px}.btn.btn-border[_v-db214e4c]:hover{border-color:#29b6f6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-db214e4c&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/layout/conteudo/modal.vue
// module id = 10
// module chunks = 0